module.exports = __webpack_public_path__ + "static/p12_I_sombraVacas-519ed1012b43987bea086f6df91b94c5.jpg";